import React from 'react';
import axios from 'axios';

import * as Globals from './Globals';


export default class Login extends React.Component {

	constructor() {
        super();

		this.state = {
            eMail: "",
            password: "",
            errorMessage: "",
            loading: false
        }
	}

	sendLoginRequest() {
        if (this.state.eMail === "" || this.state.password === "") {
            this.setState({
                errorMessage: "Geben Sie E-Mail und Passwort ein."
            });
            return null;
        }
        this.setState({
            loading: true
        });
        axios.post(Globals.BASE_PATH + 'api/getToken',
        {
            username: this.state.eMail,
            password: this.state.password
        },
        {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        }).then((response) => {
            document.cookie = Globals.COOKIE_KEY + "=" + response.data.access_token+";path=/;domain="+Globals.COOKIE_DOMAIN;
            this.props.handleLoginEvent();
        }).catch((error) => {
            if (error.response.data.error === "invalid_credentials") {
                this.setState({
                    errorMessage: "E-Mail oder Passwort nicht korrekt.",
                    loading: false
                });
            }
            this.setState({
                loading: false
            });
        });
    }

	handleEMailChange(e) {
		this.setState({
            eMail: e.target.value,
            errorMessage: ""
		});
    }

	handlePasswordChange(e) {
		this.setState({
			password: e.target.value,
            errorMessage: ""
		});
	}

    handleKeyPress(e) {
        if (e.keyCode === 13) {
            this.sendLoginRequest();
        }
    }

    renderErrorMessage() {
        if (this.state.errorMessage !== "") {
            return (
                <div className="alert alert-danger margin-bottom-sm alertIncorrectInformation">{ this.state.errorMessage }</div>
            );
        }
        return null;
    }

    showLoading() {
        if (this.state.loading) {
            return (
                <div className="sk-circle">
                    <div className="sk-circle1 sk-child"/>
                    <div className="sk-circle2 sk-child"/>
                    <div className="sk-circle3 sk-child"/>
                    <div className="sk-circle4 sk-child"/>
                    <div className="sk-circle5 sk-child"/>
                    <div className="sk-circle6 sk-child"/>
                    <div className="sk-circle7 sk-child"/>
                    <div className="sk-circle8 sk-child"/>
                    <div className="sk-circle9 sk-child"/>
                    <div className="sk-circle10 sk-child"/>
                    <div className="sk-circle11 sk-child"/>
                    <div className="sk-circle12 sk-child"/>
                </div>
            );
        }
    }

    loading() {
        if (this.state.loading) {
            return <div className="loader center-block"/>;
        } else {
            return <button className="btn btn-info center-block margin-bottom-md" onClick={ () => this.sendLoginRequest() }>Anmelden</button>;
        }
    }

    render(){
        return(
            <div>
                <nav className="navbar navbar-default login-nav">
                    <div className="container">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a style={{fontSize: "14px"}} className="navbar-brand" href="https://www.medizinische-assistenzberufe.at">
                                <span style={{marginRight: "10px"}}><img className="navbar-image-container" src="img/logo.jpg" alt="ForMed"></img></span>
                                Medizinische-Assistenzberufe
                            </a>
                        </div>

                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav navbar-right">
                                <li><a style={{fontSize: "13px"}} href="https://www.medizinische-assistenzberufe.at/?page_id=588">KURSANGEBOTE</a></li>
                                <li><a style={{fontSize: "13px"}} href="https://apis.medizinische-assistenzberufe.at/">APIS</a></li>
                                <li><a style={{fontSize: "13px"}} href="https://www.medizinische-assistenzberufe.at/e-learn/">E-LEARNING</a></li>
                            </ul>
                        </div>
                    </div>
                </nav>
                <div className="login-img-header">

                </div>
                <div className="container login">
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <div className="panel panel-default">
                                <div className="panel-heading apis-colors">
                                    <h4 className="panel-title">
                                        <strong>Login</strong>
                                    </h4>
                                </div>
                                <div className="panel-body">
                                    <div className="form-horizontal">

                                        <div className="form-group">
                                            <label htmlFor="email" className="col-md-4 control-label label-login">Email-Adresse</label>

                                            <div className="col-md-6">
                                                <input type="email" className="form-control" name="email" value={ this.state.eMail } required autoFocus onChange={ (e) => this.handleEMailChange(e) } onKeyDown={ (e) => this.handleKeyPress(e) } />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="password" className="col-md-4 control-label label-login">Passwort</label>

                                            <div className="col-md-6">
                                                <input type="password" className="form-control" value={ this.state.password } name="password" required onChange={ (e) => this.handlePasswordChange(e) } onKeyDown={ (e) => this.handleKeyPress(e) }/>
                                            </div>
                                        </div>
                                        { this.renderErrorMessage() }
                                        <div className="form-group">
                                            <div className="col-md-8 col-md-offset-4">
                                                { this.showLoading() }

                                                <button className="btn btn-info btn-logi btn-spacer-login" onClick={ () => this.sendLoginRequest() }>
                                                    Anmelden
                                                </button>

                                                <a className="btn btn-info btn-logi" href="http://apis.medizinische-assistenzberufe.at/password/reset">
                                                    Passwort vergessen?
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/Login.js